import { render, staticRenderFns } from "./InvoicedDifference.vue?vue&type=template&id=641e9952"
import script from "./InvoicedDifference.vue?vue&type=script&lang=js"
export * from "./InvoicedDifference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports